import * as types from '../constants/ActionTypes';
import * as consts from '../../home/constants/ActionTypes';

function switchContentToggle(exp) {
  return {
    type: types.SWITCH_CONTENT_TOGGLE,
    payload: exp,
  };
}

function toggleRelated(exp) {
  return {
    type: consts.TOGGLE_RELATED,
    payload: exp,
  };
}

function resetToggleRelated() {
  return {
    type: consts.RELATED_TOGGLE_RESET,
    payload: undefined,
  };
}


module.exports = {
  switchContentToggle,
  toggleRelated,
  resetToggleRelated,
};
